import React, { Component } from "react";
import './Music-List.css';
import MusicList from "./Music-List";
import { Link } from 'react-router-dom';
import axios from '../tokenInterceptor';

class AmazonMusicUnlimited extends Component {
    constructor(props) {
        super(props);
        this.state={
        }
    }

    componentWillMount =()=>{
        //this.getAmazonMusicUnlimited();
    }

    getAmazonMusicUnlimited=()=>{
        axios.get("/getAmazonMusicUnlimited").then((res)=>{
            console.log("res---", res);
        })
    }

    render() {
        return (
            <>
                <div className="right-section">
                    <div className="main-page">
                        <h3>No info available</h3>
                    </div>
                    
                </div>
            </>
        )
    }
}

export default AmazonMusicUnlimited;
